import { render } from "./NomenclaturesView.vue?vue&type=template&id=44bcff73&scoped=true"
import script from "./NomenclaturesView.vue?vue&type=script&lang=js"
export * from "./NomenclaturesView.vue?vue&type=script&lang=js"

import "./NomenclaturesView.vue?vue&type=style&index=0&id=44bcff73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bcff73"]])

export default __exports__